/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Provider_LabelInputs */

const es_privacy_policy_sharing_provider_label = /** @type {(inputs: Privacy_Policy_Sharing_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores de Servicios Esenciales`)
};

const en_privacy_policy_sharing_provider_label = /** @type {(inputs: Privacy_Policy_Sharing_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential Service Providers`)
};

/**
* | output |
* | --- |
* | "Essential Service Providers" |
*
* @param {Privacy_Policy_Sharing_Provider_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_provider_label = /** @type {((inputs?: Privacy_Policy_Sharing_Provider_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Provider_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_provider_label(inputs)
	return en_privacy_policy_sharing_provider_label(inputs)
});
export { privacy_policy_sharing_provider_label as "privacy_policy.sharing.provider_label" }